import { IScale } from './IScale';
import { LinearScale } from './LinearScale';

export class VerticalScale extends LinearScale implements IScale {
    private _height: number;

    constructor(height: number, min: number, max: number) {
        super(min, max);
        this.height(height);
    }

    size(value?: number): number {
        return this.height(value);
    }

    height(value?: number): number {
        if (value) {
            this._height = value;
            this.scale().range([this.height(), 0]);
        }
        return this._height;
    }
}